/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { IImageSettings } from '@msdyn365-commerce/core-internal';
import { IUnitOfMeasureConversionResponseMapEntity } from '../../../actions/DataServiceEntities.g';
import MilSearchSuggestionProduct from './mil-search-suggestion-product.component';
import { IMilSearchResources } from '../mil-search.props.autogenerated';
import { ICustomSearchSuggestionHitsEntity } from '../mil-search';

export interface IMilSearchSuggestionsItems {
    products?: SimpleProduct[] | undefined;
    context: any;
    telemetryContent?: ITelemetryContent;
    id: string;
    typeName: string;
    imageSettings?: IImageSettings;
    uomData: IUnitOfMeasureConversionResponseMapEntity[] | undefined;
    resources: IMilSearchResources;
    luigisResp: ICustomSearchSuggestionHitsEntity[];
}

export const MilSearchSuggestionsItems: React.FC<IMilSearchSuggestionsItems> = props => {
    const { products = [], context, telemetryContent, id, typeName, imageSettings, uomData, resources, luigisResp } = props;

    if (!products || products.length === 0 || luigisResp.length === 0) {
        return null;
    }

    return (
        <ul className={'mil-grid-view'}>
            {products.map((product, idx) => {
                const key = product?.RecordId ?? idx;
                const productUom = uomData?.find(uom => uom.ItemRecId === product.RecordId);
                let title = luigisResp.find(prod => prod.Url === product.RecordId)?.Attributes?.Title || '';
                if (!title) {
                    luigisResp.find(prod => prod.Attributes?.ItemNumber?.[0] === product.ItemId)?.Attributes?.Title;
                }

                const milItemNumProp = luigisResp?.find(prod => prod.Url === product.RecordId)?.Attributes?.MilItemNum?.[0];
                // const milItemNumProp = 'test';

                return (
                    <li className='ms-product-search-result__item' key={key}>
                        <MilSearchSuggestionProduct
                            context={context}
                            telemetryContent={telemetryContent}
                            imageSettings={imageSettings}
                            freePriceText={resources.priceFree}
                            originalPriceText={resources.originalPriceText}
                            currentPriceText={resources.currentPriceText}
                            shouldDisplayPrice={!!products}
                            ratingAriaLabel={resources.ratingAriaLabel}
                            id={id}
                            key={product.RecordId}
                            typeName={typeName}
                            product={product}
                            productUom={productUom}
                            title={title}
                            milItemNumProp={milItemNumProp}
                        />
                    </li>
                );
            })}
        </ul>
    );
};

export default MilSearchSuggestionsItems;
